import { IonButton, IonInput, IonItem } from '@ionic/react';
import { useFormik } from 'formik';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

interface Props {
  onSearch: (mark: string) => void;
}

const validationSchema = yup.object({
  mark: yup
    .number()
    .typeError(i18next.t('FORMS.ERRORS.INVALID_TYPE'))
    .required(i18next.t('FORMS.ERRORS.REQUIRED_FIELD')),
});

export const DeliveryRetrieveDocByMark = ({ onSearch }: Props) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      mark: '',
    },
    validationSchema,
    onSubmit: (values) => {
      onSearch(String(values.mark));
    },
  });

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="margin-b-16 flex-start-center-column-nowrap">
          <div className="padding-b-16 padding-l-12">{t('DELIVERY.RETRIEVE_BY_MARK')}</div>
          <IonItem
            className={`width-300px height-50px border-radius-input g-select-border ${
              formik.touched.mark && formik.errors.mark ? 'b-field-border-error' : ''
            }`}
            mode="md">
            <IonInput
              className="height-48px"
              mode="md"
              type="number"
              aria-label="mark"
              name="mark"
              placeholder={t('DELIVERY.NEW_DELIVERY_MARK_PLACEHOLDER') + '...'}
              onIonInput={formik.handleChange}
              onIonBlur={formik.handleBlur}
              value={formik.values.mark}
            />
          </IonItem>
        </div>
        <div className="flex-center-center-column-nowrap width-100">
          <IonButton mode="md" type="submit" disabled={!formik.isValid || !formik.dirty} className="width-350px">
            {t('DELIVERY.NEW_DELIVERY_NEXT')}
          </IonButton>
        </div>
      </form>
    </div>
  );
};
